import AgentProfile from "@/views/console/AgentProfile.vue";
import C from "@/utils/constants";

export default [
  {
    path: "agent-profile",
    component: AgentProfile,
    meta: {
      roles: [C.ROLE.AGENT],
    },
    children: [
      {
        path: "",
        name: "agent-profile",
        component: () =>
          import("../components/console/agent-profile/AgentProfileDetails.vue"),
        meta: {
          roles: [C.ROLE.AGENT],
        },
      },
    ],
  },
];
